/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
import { Box, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import XCircle from "../../../../../public/assets/icons/XCircle";
import { isEmpty } from "../../../../utils/constants/constants";
import { quizAnswerType } from "../../utils/constant";
import RollBackIcon from "../../../../../public/assets/icons/RollBackIcon";

function SelectionsCard({
  selectionData,
  question,
  questionId,
  addDataToState,
  answerTotalQuestion,
  solutionData,
  answerType
}: any) {
  const [arraySelectionData, setArraySelectionData] = useState<any>([]);
  const [itemsData, setItemsData] = useState<any>([]);
  const theme: any = useTheme();
  const getResultContent = () => {
    const selections = JSON.parse(question?.options[0]?.items[0]?.content || "[]")?.selections;
    return selections?.map((element, index) => {
      const sumBeforeIndex = index > 0 ? selections?.slice(0, index).reduce((a, b) => a + b, 0) : 0;
      return index === 0
        ? solutionData?.correct_options?.slice(0, element)
        : solutionData?.correct_options?.slice(sumBeforeIndex, sumBeforeIndex + selections[index]);
    });
  };
  const checkShowCorrectAnswer = solutionData && !solutionData?.correct && !solutionData?.skipped;
  const actionClickCharacter = (v: any) => {
    const tempArraySelectionData = arraySelectionData;
    if (Array.isArray(arraySelectionData[0])) {
      arraySelectionData?.find((ele: any, i: string | number) => {
        const indexEmpty = ele.findIndex((e: any) => !e);
        if (indexEmpty > -1) {
          tempArraySelectionData[i][indexEmpty] = v;
          return true;
        }
        return false;
      });
    } else if (arraySelectionData.some((ele: any) => ele?.length > 1)) {
      const indexNull = arraySelectionData.findIndex((el: any) => !el);
      if (indexNull > -1) {
        tempArraySelectionData[indexNull] = v;
      }
    } else {
      const indexNull = arraySelectionData.findIndex((el: any) => !el);
      if (indexNull > -1) {
        tempArraySelectionData[indexNull] = v;
      }
    }
    addDataToState(tempArraySelectionData, questionId);
  };

  useEffect(() => {
    if (isEmpty(solutionData)) {
      let tempArraySelectionData = JSON.parse(selectionData || "{}")?.selections;
      let tempItemData: any[];
      if (tempArraySelectionData?.length > 1) {
        // trường hợp chọn từ thành câu hoặc chọn chữ thành từ
        if (answerTotalQuestion) {
          // đã chọn rồi
          const tempAnswerTotal = JSON.parse(JSON.stringify([answerTotalQuestion?.selections.join("")]));
          if (tempAnswerTotal.some((ele: string | any[]) => ele.length > 1)) {
            tempArraySelectionData = answerTotalQuestion?.selections;
          } else {
            tempArraySelectionData = tempArraySelectionData.map((ele: any) => Array.from(Array(ele)));
            tempArraySelectionData.forEach((v: any[], i: number) =>
              v.forEach((q: any, j: number) => {
                tempArraySelectionData[i][j] = tempAnswerTotal[0]?.charAt(
                  i * (tempArraySelectionData[i - 1] || []).length + j
                )
                  ? tempAnswerTotal[0]?.charAt(i * (tempArraySelectionData[i - 1] || []).length + j)
                  : null;
              })
            );
          }
        } else if (tempArraySelectionData.every((ele: number) => ele === 1)) {
          // get default data, câu không chia block
          tempArraySelectionData = tempArraySelectionData.map(() => null);
        } else {
          // get default data, câu có chia block
          tempArraySelectionData = tempArraySelectionData.map((ele: any) => Array.from(Array(ele)));
        }
        setArraySelectionData(tempArraySelectionData);
        const flatArray = tempArraySelectionData.flat();
        tempItemData = JSON.parse(JSON.stringify(JSON.parse(selectionData)?.items));
        flatArray?.forEach((val: any) => {
          if (val) {
            const indexVal = tempItemData.findIndex((el) => el === val);
            tempItemData = tempItemData.filter((ele, ix) => ix !== indexVal);
          }
        });
        setItemsData(tempItemData);
      } else {
        // chỉ chọn 1 chữ
        const tempArraySelectionDataSingleCharacter = Array.from(
          Array(JSON.parse(selectionData || "{}")?.selections ? JSON.parse(selectionData)?.selections[0] : undefined)
        );
        if (answerTotalQuestion) {
          tempArraySelectionDataSingleCharacter.forEach((ele, ix) => {
            tempArraySelectionDataSingleCharacter[ix] = answerTotalQuestion?.selections[0]?.charAt(ix);
          });
        }
        tempItemData = JSON.parse(selectionData || "{}")?.items;

        tempArraySelectionDataSingleCharacter?.forEach((val) => {
          if (val) {
            const indexVal = tempItemData.findIndex((el) => el === val);
            tempItemData = tempItemData.filter((ele, ix) => ix !== indexVal);
          }
        });
        setArraySelectionData(tempArraySelectionDataSingleCharacter);
        setItemsData(tempItemData);
      }
    } else {
      setItemsData([]);
      let tempArraySelectionDataSingleCharacter: any = [];
      const questionOptionSelections = JSON.parse(question.options[0].items[0].content || "{}").selections;
      if (questionOptionSelections?.length > 1 && questionOptionSelections?.findIndex((e: number) => e > 1) > -1) {
        // tìm những câu có selections chia block, ví dụ: selections: [2, 4]
        questionOptionSelections.forEach((ele: any, idx: number) => {
          let arrayBlock: any = [];
          if (idx === 0) {
            arrayBlock = !isEmpty(solutionData?.answered_options)
              ? solutionData?.answered_options?.slice(idx, ele)
              : solutionData?.correct_options?.slice(idx, ele);
          } else {
            const indexSlice = questionOptionSelections.slice(0, idx).reduce((x: any, y: any) => x + y, 0);
            arrayBlock = !isEmpty(solutionData?.answered_options)
              ? solutionData?.answered_options?.slice(indexSlice, indexSlice + ele)
              : solutionData?.correct_options?.slice(indexSlice, indexSlice + ele);
          }
          tempArraySelectionDataSingleCharacter.push(arrayBlock);
        });
      } else {
        if (solutionData?.answered_options && answerType === quizAnswerType.CONCAT_WORD) {
          tempArraySelectionDataSingleCharacter = solutionData?.answered_options;
          setArraySelectionData(tempArraySelectionDataSingleCharacter);
          return;
        }
        tempArraySelectionDataSingleCharacter = solutionData?.answered_options
          ? answerType === quizAnswerType.CONCAT_LETTER_EN ||
            answerType === quizAnswerType.CONCAT_LETTER_VI ||
            answerType === quizAnswerType.CONCAT_NUMBER
            ? solutionData?.answered_options?.map((element: string) => {
                return element.split("");
              })
            : solutionData?.answered_options?.map((element: any) => {
                return element;
              })
          : answerType === quizAnswerType.CONCAT_LETTER_EN ||
            answerType === quizAnswerType.CONCAT_LETTER_VI ||
            answerType === quizAnswerType.CONCAT_NUMBER
          ? solutionData?.correct_options?.map((element: string) => {
              return element.split("");
            })
          : solutionData?.correct_options?.map((element: any) => {
              return element;
            });
      }
      setArraySelectionData(tempArraySelectionDataSingleCharacter);
    }
    // eslint-disable-next-line
  }, [answerTotalQuestion, solutionData]);
  const getBeforeSelections = () => {
    const tempArr = arraySelectionData.flat()?.map((ele, idx) => {
      return arraySelectionData?.flat()?.findLastIndex((e) => !isEmpty(e)) === idx ? "" : ele;
    });
    if (!arraySelectionData?.some((e) => Array.isArray(e))) {
      return arraySelectionData?.map((element) =>
        arraySelectionData?.findLast((e) => !!e) === element ? "" : element
      );
    }
    return arraySelectionData?.map((element, index) => {
      const sumBeforeIndex = index > 0 ? arraySelectionData?.slice(0, index).reduce((a, b) => a + b?.length, 0) : 0;
      return index === 0
        ? tempArr?.slice(0, element?.length)
        : tempArr?.slice(sumBeforeIndex, sumBeforeIndex + arraySelectionData[index]?.length);
    });
  };
  return (
    <div className="flex flex-col w-full">
      <Box minHeight="78px" className="center-col" mb={3}>
        <Box className="center-row" width="100%" flexWrap="wrap">
          {arraySelectionData?.map((ele: any, index: number) =>
            Array.isArray(ele) ? (
              <Box key={index} marginRight={ele?.length > 1 ? "30px" : "20px"} className="center-row" flexWrap="wrap">
                {ele?.map((el, idx) => (
                  <Box
                    key={idx}
                    style={{
                      border: !solutionData ? `1px solid ${theme.answerOptions.gray}` : "none",
                      borderRadius: 16,
                      textTransform: "uppercase",
                      background: solutionData
                        ? solutionData?.correct
                          ? theme.answerOptions.correct
                          : solutionData?.skipped
                          ? theme.answerOptions?.skipped
                          : theme.answerOptions?.inCorrect
                        : "none",
                      color: solutionData ? "white" : theme.answerOptions.black
                    }}
                    mt={1}
                    className="center-row px-1"
                    marginRight={arraySelectionData?.length > 1 ? "5px" : "20px"}
                  >
                    <span className="borderSelection center-row">{el}</span>
                  </Box>
                ))}
              </Box>
            ) : (
              <Box
                key={index}
                style={{
                  border: !solutionData ? `1px solid ${theme.answerOptions.gray}` : "none",
                  background: solutionData
                    ? solutionData?.correct
                      ? theme.answerOptions.correct
                      : solutionData?.skipped
                      ? theme.answerOptions?.skipped
                      : theme.answerOptions?.inCorrect
                    : "none",
                  color: solutionData ? "white" : theme.answerOptions.black
                }}
                flexWrap="wrap"
                className="center-row selection-quiz"
              >
                <span className="borderSelection center-row">{ele}</span>
              </Box>
            )
          )}
          {isEmpty(solutionData) && (
            <Box mt={1} className="flex flex-col items-center ml-[-10px]">
              <button
                type="button"
                onClick={() => {
                  addDataToState([], questionId);
                }}
              >
                <XCircle />
              </button>
              <button
                type="button"
                onClick={() => {
                  addDataToState(getBeforeSelections(), questionId);
                }}
              >
                <RollBackIcon />
              </button>
            </Box>
          )}
        </Box>
        {!solutionData && (
          <Box display="flex" mt={5} height="100%" flexWrap="wrap" justifyContent="center">
            {itemsData?.map((v: any, index: number) => (
              <Box
                key={index}
                mt={2}
                className="flex justify-center items-center selection-quiz bg-green-gradient text-white cursor-pointer px-2"
                onClick={() => {
                  if (isEmpty(solutionData)) {
                    actionClickCharacter(v);
                  }
                }}
              >
                {v}
              </Box>
            ))}
          </Box>
        )}
      </Box>
      <Box className="flex flex-wrap center-row">
        {checkShowCorrectAnswer &&
          getResultContent()?.map((content) => (
            <Box key={content.id} marginRight="30px" className="center-row gap-[20px]">
              {content?.map((el, idx) => (
                <Box
                  key={idx}
                  style={{
                    borderRadius: 16,
                    textTransform: "uppercase",
                    background: theme.answerOptions.correct,
                    color: "white"
                  }}
                  mt={1}
                  className="px-1"
                >
                  <span className="borderSelection center-row">{el}</span>
                </Box>
              ))}
            </Box>
          ))}
      </Box>
      {/* <div>
        {solutionData && (
          <span className="text-gray1 text-[13px]">
            <FormattedMessage id="quiz.answer" />
            {getResultContent()?.map((e) => e?.join(""))?.join(" ")}
          </span>
        )}
      </div> */}
    </div>
  );
}

export default SelectionsCard;
